import React, {
  useEffect,
  useState,
  useCallback,
} from 'react'
import { useHistory } from 'react-router-dom'
import DashedLink from '../DashedLink'

import './index.css'
import DatePickerReports from '../DatePickerReports'

const DownloadReportsBlock = ({
                                setReports,
                                setReportsToJob,
                                setReportsToDealers,
                                setReportsToEmployees,
                                toggleDatePickerReports,
                                jobReports,
                                dealerReports,
                                employeeReports,
                                listJobReports,
                                listDealerReports,
                                listUserReports,
                                startDateReport,
                                endDateReport,
                                title,
                                match,
                              }) => {

  useEffect(() => {
    setReports()
  }, [])
  const [ showDatePickerDealerReports, setShowDatePickerDealerReports ] = useState(false)

  // console.log(endDateReport.format('YYYY/MM/DD'), startDateReport.format('YYYY/MM/DD'))
  const [ paramJobId, setParamJobId ] = useState('')
  const [ paramDealer, setParamDealer ] = useState('')
  const [ paramEmployee, setParamEmployee ] = useState('')
  const [reportName, setReportName] = useState('')
  const [reportType, setReportType] = useState('')
  let history = useHistory()

  useEffect(() => {
    setParamJobId(match.params.jobId)
  }, [ match.params.jobId ])

  useEffect(() => {
    setParamDealer(match.params.dealerId)
  }, [ match.params.dealerId ])

  useEffect(() => {
    setParamEmployee(match.params.employeeId)
  }, [ match.params.employeeId ])


  const getDataForTableReports = useCallback((reportName, reportParams, typeReport, actionCreator) => {
    setReportName(reportName)
    setReportType(typeReport)
    if (typeReport === 'uuid_and_time_range') {
      toggleDatePickerDealerReports()
    } else if (typeReport === 'uuid') {
      actionCreator(reportName, { 'uuid': reportParams })
      history.push(`/jobs/${match.params.jobId}/reports/${reportName}`)
    } else {
      actionCreator(reportName)
    }
  }, [])

  const toggleDatePickerDealerReports = () => {
    setShowDatePickerDealerReports(!showDatePickerDealerReports)
  }


  return (
    <div className="download-reports">
      <h3 className="download-reports__title">Reports</h3>
      <div className="download-reports__body">
        {title === 'Job Reports' && jobReports && jobReports.map((elem, index) => <DashedLink
          name={elem.description}
          onClick={() => getDataForTableReports(elem.reportName, paramJobId, elem.paramType, setReportsToJob)}
          className="download-reports__button"
          key={index}
        />)}
        {title === 'Dealer Reports' && dealerReports && dealerReports.map((elem, index) => <DashedLink
          name={elem.description}
          onClick={() => getDataForTableReports(elem.reportName, paramDealer, elem.paramType, setReportsToDealers)}
          className="download-reports__button"
          key={index}
        />)}
        {title === 'Employees' && employeeReports && employeeReports.map((elem, index) => <DashedLink
          name={elem.description}
          onClick={() => getDataForTableReports(elem.reportName, paramEmployee, elem.paramType, setReportsToEmployees)}
          className="download-reports__button"
          key={index}
        />)}
      </div>

      {
        showDatePickerDealerReports &&
        <DatePickerReports reportType={reportType} reportName={reportName} toggleModal={toggleDatePickerDealerReports}/>
      }
    </div>
  )
}

export default DownloadReportsBlock
